/* global axios */
import ApiClient from './ApiClient';

class NotificationAutoRepliesAPI extends ApiClient {
  constructor() {
    super('notification_auto_replies', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { notification_auto_reply: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { notification_auto_reply: data });
  }

  toggle(id) {
    return axios.post(`${this.url}/${id}/toggle`);
  }
}

export default new NotificationAutoRepliesAPI();
